import React from 'react';
import PropTypes from 'prop-types';

import CloudinaryImage from '@stubhub/react-cloudinary';

import {makeSellCarouselImages} from './utils';

import './index.scss';

const SellSearchCarousel = ({deviceType}) => {
  const carouselImages = makeSellCarouselImages(deviceType);

  return (
    <div className="SellSearchCarousel__bannerContainer">
        <div className="SellSearchCarousel__slide-show">
          {Object.keys(carouselImages).map((image) => {
            const {alt, src} = carouselImages[image];

            return (
              <div
                className="SellSearchCarousel__slide-show-image"
                key={image}
              >
                <CloudinaryImage
                  className="SellSearchCarousel__background-image"
                  src={src}
                  alt={alt}
                  onError={(event) =>
                    event.target.classList.add('SellSearchCarousel__errorCss')
                  }
                  enableCloudinary
                  editZoomUrl={false}
                  useNamedTransforms={false}
                />
                
              </div>
            );
          })}
        </div>
    </div>
  );
};

SellSearchCarousel.propTypes = {
  deviceType: PropTypes.string.isRequired,
};

export default SellSearchCarousel;
